import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ArrowBack, MailOutline } from "@mui/icons-material";
import { useTheme } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { actionGetClientTheme } from "../../../actions/AppSettings.action";
import { getClientDomain } from "../../../libs/domain.utils";

import "./ForgotPasswordSuccessView.css";
import DashboardSnackbar from "../../../components/Snackbar.component";

function ForgotPasswordSuccessView() {
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const appSettings = useSelector((state) => state.app_setting);
  const clientTheme = appSettings?.client_theme;

  const email = location.state?.email || "";

  useEffect(() => {
    const domain = getClientDomain();
    if (domain && !clientTheme) {
      dispatch(actionGetClientTheme(domain));
    }
  }, [dispatch, clientTheme]);

  useEffect(() => {
    if (clientTheme?.fav_icon) {
      const link = document.querySelector("link[rel='shortcut icon']");
      if (link) {
        link.href = clientTheme.fav_icon;
      }
    }
  }, [clientTheme]);

  useEffect(() => {
    // Prevent opening this page directly without coming from Forgot Password
    if (!email) {
      history.replace("/forgot-password");
    }
  }, [email, history]);

  return (
    <div
      className="forgotPasswordSuccessPage"
      style={clientTheme?.background_image ? { backgroundImage: `url(${clientTheme.background_image})` } : {}}
    >
      <div
        className="forgotPasswordSuccessOverlay"
        style={clientTheme?.background_image ? { backgroundImage: `url(${clientTheme.background_image})` } : {}}
      ></div>

      <div className="forgotPasswordSuccessContainer">
        <div className="forgotPasswordSuccessCard">

          {/* Logo */}
          <div className="forgotPasswordSuccessLogoWrapper">
            <img
              src={
                clientTheme?.display_logo ||
                require("../../../assets/CRMAssets/psconnect_login_logo@2x.png")
              }
              alt="PS Connect"
              className="forgotPasswordSuccessLogo"
              style={{
                maxHeight: "80px",
                maxWidth: "220px",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>

          <div className="forgotPasswordSuccessContent">

            {/* Mail Icon */}
            <div className="forgotPasswordSuccessIconWrapper">
              <div className="forgotPasswordSuccessIcon">
                <MailOutline
                  style={{
                    fontSize: 45,
                    color: theme.palette.primary.main,
                  }}
                />
              </div>
            </div>

            {/* Heading */}
            <Typography className="forgotPasswordSuccessTitle">
              Check Your Email
            </Typography>

            {/* Description */}
            <Typography className="forgotPasswordSuccessDescription">
              A password reset link has been sent to
            </Typography>

            <Typography
              className="forgotPasswordSuccessEmail"
              style={{
                color: theme.palette.primary.main,
              }}
            >
              {email}
            </Typography>

            <Typography className="forgotPasswordSuccessInstruction">
              Click the link in the email to reset your password.
              <br />
              The link will expire in 1 hour.
            </Typography>

            {/* Info Box */}
            <div className="forgotPasswordSuccessInfoBox">
              <Typography variant="body2">
                <strong>Didn't receive it?</strong>{" "}
                <span className="forgotPasswordSuccessInfoText">
                  Check your spam folder or{" "}
                </span>

                <Link
                  to={{
                    pathname: "/forgot-password",
                    search: window.location.search,
                  }}
                  className="forgotPasswordSuccessRetryLink"
                >
                  try a different email address.
                </Link>
              </Typography>
            </div>

            {/* Back Link */}
            <div className="forgotPasswordSuccessBackWrapper">
              <Link
                to={{
                  pathname: "/forgot-password",
                  search: window.location.search,
                }}
                className="forgotPasswordSuccessBackLink"
              >
                <ArrowBack
                  style={{
                    color: theme.palette.primary.main,
                    marginRight: 6,
                    fontSize: 20,
                  }}
                />

                <Typography
                  className="forgotPasswordSuccessBackText"
                  style={{
                    color: theme.palette.primary.main,
                  }}
                >
                  Back to Forgot Password
                </Typography>
              </Link>
            </div>

          </div>
        </div>

        <DashboardSnackbar />
      </div>
    </div>
  );
}

export default ForgotPasswordSuccessView;